import React, { useEffect, useState } from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';
import { getAllData } from 'apis/customApiHandler';

const Email = ({ data, handleClick }) => {
  const [initialValues, setInitialValues] = React.useState({
    email: data?.email || '',
    id: data._id
  });
  const [inputs, setInputs] = useState([])
  const [loading, setLoading] = useState(false)

  const getEmailHistory = async()=>{
    setLoading(true)
    try{
    const response = await getAllData("/manage-dtp/email-list", {
      fleet: data.fleet._id,
      currentDate: data.createdAt,
    })
    console.log(response)
    setInitialValues({...initialValues, email:  response.data?.emails?.join(", ")})
    setInputs(inputFields)
  }catch(err){
    console.log({err})
  }finally{
    setLoading(false)
  }
  }
  useEffect(()=>{
    getEmailHistory();
  }, [data])

  useEffect(()=>{
    console.log({initialValues})
  }, [initialValues])

  const inputFields = [
    {
      name: 'email',
      label: 'Email     (enter comma seperated values)',
      placeholder: "For eg: chetan.tp@jkmail.com, krishan.sharma@jkmail.com",
      type: 'textarea',
      required: true,
      // maxlength: "200",
      rows: "10",
      className: "w-[100%] col-span-2",
    },
  ];

  return (
    inputs?.length ?<CustomAddPage
      pageTitle={"Send Email"}
      disabled={loading}
      url={'manage-dtp/email'}
      action={'create'}
      updateId={data?._id}
      queryKey="manage-dtp-email"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />: <>...</>
  );
};

export default Email;
